import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@ordr-as/umami-react'
import { ArrowLeftIcon } from '@ordr-as/icons'

const BackButton = ({
    children,
    returnUrl,
    beforeNavigate,
}: {
    children?: ReactNode
    returnUrl?: string

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    beforeNavigate?: () => Promise<boolean>
}) => {
    const navigate = useNavigate()

    const goBack = () => {
        if (beforeNavigate) {
            beforeNavigate().then((shouldNavigate) => {
                if (!shouldNavigate) return
                return returnUrl ? navigate(returnUrl) : navigate(-1)
            })
            return
        }

        returnUrl ? navigate(returnUrl) : navigate(-1)
    }

    return (
        <Button onClick={() => goBack()} height={48} className="justify-start px-3">
            <ArrowLeftIcon className="mr-1" />
            {children}
        </Button>
    )
}

export default BackButton
